import { useAuth } from "@/contexts/AuthContext";
import { useSuspenseQueries } from "@tanstack/react-query";
import {
  getNotificationPreferences,
  getNotifications,
} from "@/api/notifications";

export function useNotificationsQuery() {
  const { user } = useAuth();
  const [notificationsQuery, preferencesQuery] = useSuspenseQueries({
    queries: [
      {
        queryKey: ["notifications", user?.id],
        refetchInterval: user ? 60000 : false,
        queryFn: async () => {
          return user ? getNotifications() : [];
        },
      },
      {
        queryKey: ["notification-preferences", user?.id],
        queryFn: async () => {
          return user ? getNotificationPreferences() : null;
        },
      },
    ],
  });

  return { notificationsQuery, preferencesQuery };
}
